import styled, { css } from 'styled-components';

export const CardItem = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 8px 0;
`;

export const CardItemRow = styled.div`
  display: flex;
  gap: 21px;
`;

export const CardItemCollumn = styled.div`
  ${({ collumnDomain, last }) => css`
    margin: ${last ? '0 0 0 auto' : '0'};
    min-width: ${collumnDomain ? '0' : 'auto'};
    position: relative;
  `}
`;

export const WrapperIcon = styled.div`
  ${({ theme }) => css`
    @media (max-width: ${theme.v2.breakpoints.md}) {
      svg {
        height: 16px;
        width: 16px;
      }
    }
  `}
`;

export const WrapperCardItemTitle = styled.div`
  align-items: center;
  display: flex;
  gap: 8px;
  width: 100%;
`;

export const CardItemTitle = styled.div`
  ${({ theme }) => css`
    color: ${theme.v2.colors.neutral.lowDark};
    font-size: ${theme.v2.font.sizes.xs};
    font-weight: ${theme.v2.font.weights.medium};
    line-height: 1.2;
    min-height: 16px;
    position: relative;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  `}
`;

export const CardItemSubtitle = styled.div`
  ${({ theme }) => css`
    color: ${theme.v2.colors.neutral.lowMedium};
    font-size: ${theme.v2.font.sizes.xxxs};
    font-weight: ${theme.v2.font.weights.medium};
    line-height: 1;
    margin-top: 8px;
  `}
`;

export const WrapperDomain = styled.div`
  display: flex;
`;

export const DomainSld = styled.div`
  min-width: 0;
  overflow: hidden;
  position: relative;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const DomainTld = styled.div`
  position: relative;
  white-space: nowrap;
`;
